import { render, staticRenderFns } from "./TriggeredAlarms.vue?vue&type=template&id=6cb8db6a&scoped=true"
import script from "./TriggeredAlarms.vue?vue&type=script&lang=js"
export * from "./TriggeredAlarms.vue?vue&type=script&lang=js"
import style0 from "./TriggeredAlarms.vue?vue&type=style&index=0&id=6cb8db6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb8db6a",
  null
  
)

/* custom blocks */
import block0 from "./TriggeredAlarms.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports